export const asset_sub_type = {
  state: {
    asset_sub_types: []
  },
  mutations: {
    updateAssetSubTypes: function(state, newList) {
      state.asset_sub_types = newList;
    }
  },
  getters: {
    getAllAssetSubTypes(state) {
      return state.asset_sub_types;
    },
    getAssetSubTypesByType(state) {
      return function(assetType) {
        return state.asset_sub_types.filter(function(a) {
          return (a.type == assetType)
        });
      }
    },
    getAssetSubType(state) {
      return function(uuid) {
        return state.asset_sub_types.find(function(a) {
          return (a.uuid == uuid)
        })
      }
    },
    getAssetTypes(state) {
      return state.asset_sub_types.reduce(function(types, asset_sub_type) {
        if (!types.includes(asset_sub_type.type)) {
          types.push(asset_sub_type.type);
        }
        return types;
      }, [])
    }
  }
}